import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MicOff, Lock, Mic, CheckCircle, RefreshCw } from "lucide-react";

interface MicrophonePermissionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRetry: () => void;
}

export function MicrophonePermissionModal({
  open,
  onOpenChange,
  onRetry,
}: MicrophonePermissionModalProps) {
  const handleRefreshPage = () => {
    window.location.reload();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <MicOff className="h-8 w-8 text-destructive" />
          </div>
          <DialogTitle className="text-center text-xl">
            Permissão de Microfone Necessária
          </DialogTitle>
          <DialogDescription className="text-center">
            O navegador bloqueou o acesso ao seu microfone. Para fazer chamadas, você precisa permitir o acesso.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-4">
          <p className="text-sm font-medium text-foreground">
            Siga os passos abaixo para liberar:
          </p>

          <div className="space-y-3">
            {/* Passo 1 */}
            <div className="flex items-start gap-3 rounded-lg border bg-muted/50 p-3">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Lock className="h-4 w-4" />
              </div>
              <div>
                <p className="font-medium text-sm">1. Clique no cadeado</p>
                <p className="text-xs text-muted-foreground">
                  Na barra de endereço do navegador, clique no ícone de cadeado 🔒 à esquerda da URL
                </p>
              </div>
            </div>

            {/* Passo 2 */}
            <div className="flex items-start gap-3 rounded-lg border bg-muted/50 p-3">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Mic className="h-4 w-4" />
              </div>
              <div>
                <p className="font-medium text-sm">2. Encontre "Microfone"</p>
                <p className="text-xs text-muted-foreground">
                  Procure a opção "Microfone" nas configurações do site
                </p>
              </div>
            </div>

            {/* Passo 3 */}
            <div className="flex items-start gap-3 rounded-lg border bg-muted/50 p-3">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <CheckCircle className="h-4 w-4" />
              </div>
              <div>
                <p className="font-medium text-sm">3. Mude para "Permitir"</p>
                <p className="text-xs text-muted-foreground">
                  Altere de "Bloquear" para "Permitir" e atualize a página
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-2">
          <Button onClick={onRetry} className="w-full gap-2">
            <Mic className="h-4 w-4" />
            Tentar Novamente
          </Button>
          <Button variant="outline" onClick={handleRefreshPage} className="w-full gap-2">
            <RefreshCw className="h-4 w-4" />
            Atualizar Página
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
